var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10.909091,
    rx: 1,
    width: 15.272727,
    x: 0.727273,
    y: 0.727273
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07319c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00247e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f8bde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1075c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#187536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e5023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51931"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#n"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.727273.727273h15.272727v10.909091h-15.272727z",
    fill: "url(#c)",
    fillRule: "nonzero",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10.181818 3.636364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.54545455v-2.17480469c0-.20470427.15625-.37064986.36196275-.37064986h2.91243814c.1999065 0 .36196275.16480463.36196275.37064986v2.17480469c0 1.81818181-1.81818182 2.54545454-1.81818182 2.54545454s-1.81818182-.72727273-1.81818182-2.54545454zm1.92299543 2.08703738c.19135994-.1084373.38310142-.24265634.56101739-.40278071.49688252-.44719427.78871445-1.00167494.78871445-1.68425667v-2.17480469c0-.0063564-2.91011081-.0070135-2.91011081-.0070135.00046865.00041949.0010199 2.18181819.0010199 2.18181819 0 .68258173.29183194 1.2370624.78871445 1.68425667.17791598.16012437.36965746.29434341.5610174.40278071.03836418.02173971.07349256.04071044.10481361.05694673.03132105-.01623629.06644942-.03520702.10481361-.05694673z",
    fill: "url(#a)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.84232955 2.52698864c-.06354413-.19063238.04185416-.34517046.24522607-.34517046h1.46125239c.19897875 0 .30972082.15168623.24522608.34517046l-.13352273.40056817c-.06354412.19063238-.21481967.22205978-.38148741.09659091 0 0 .06419338-.11505681-.46084213-.11505681s-.46084213.11505681-.46084213.11505681c-.14714556.1372867-.31699268.09689332-.38148741-.09659091z",
    fill: "url(#e)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.09090909 2.18181818c.19686108.03912514.42943493-.36363636.72727273-.36363636.31762745 0 .52790379.41249452.72727273.36363636.17880455-.04381857.36363636-.53736272.36363636-.72727273 0-.40166163-.48841664-.72727272-1.09090909-.72727272s-1.09090909.32561109-1.09090909.72727272c0 .20310311.16226955.6872521.36363636.72727273z",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.2350715 4.49220124c.05681819-.05681819.05681819-.05681819.25436471-.25436472l.21854332-.21854331c.06958182-.06958183.1819802-.06961947.25159967 0l.21854331.21854331c.21155212.21155212.55419228.21166688.76585916 0l.21854331-.21854331c.06958183-.06958183.1819802-.06961947.25159968 0l.21854331.21854331c.21155211.21155212.55419227.21166688.76585915 0l.21854331-.21854331c.06958184-.06958183.18198021-.06961947.25159968 0l.21854331.21854331.12856487.12856488.25712974-.25712974-.12856487-.12856487-.21854331-.21854331c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.2185433.21854331c-.06961948.06961947-.18201785.06958183-.25159968 0l-.21854331-.21854331c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.21854331.21854331c-.06961948.06961947-.18201785.06958183-.25159968 0l-.21854331-.21854331c-.21166688-.21166688-.55430703-.21155212-.76585915 0l-.21854332.21854331-.2543647.2543647-.12856487.12856487.25712974.25712974z",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.2350715 3.40129215c.05681819-.05681819.05681819-.05681819.25436471-.25436472l.21854332-.21854331c.06958182-.06958183.1819802-.06961947.25159967 0l.21854331.21854331c.21155212.21155212.55419228.21166688.76585916 0l.21854331-.21854331c.06958183-.06958183.1819802-.06961947.25159968 0l.21854331.21854331c.21155211.21155212.55419227.21166688.76585915 0l.21854331-.21854331c.06958184-.06958183.18198021-.06961947.25159968 0l.21854331.21854331.12856487.12856488.25712974-.25712974-.12856487-.12856488-.21854331-.2185433c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.2185433.2185433c-.06961948.06961948-.18201785.06958184-.25159968 0l-.21854331-.2185433c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.21854331.2185433c-.06961948.06961948-.18201785.06958184-.25159968 0l-.21854331-.2185433c-.21166688-.21166688-.55430703-.21155212-.76585915 0l-.21854332.2185433-.2543647.25436471-.12856487.12856487.25712974.25712974z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.2350715 5.58311033c.05681819-.05681818.05681819-.05681818.25436471-.25436472l.21854332-.2185433c.06958182-.06958184.1819802-.06961948.25159967 0l.21854331.2185433c.21155212.21155212.55419228.21166688.76585916 0l.21854331-.2185433c.06958183-.06958184.1819802-.06961948.25159968 0l.21854331.2185433c.21155211.21155212.55419227.21166688.76585915 0l.21854331-.2185433c.06958184-.06958184.18198021-.06961948.25159968 0l.21854331.2185433.12856487.12856488.25712974-.25712974-.12856487-.12856487-.21854331-.21854331c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.2185433.21854331c-.06961948.06961947-.18201785.06958183-.25159968 0l-.21854331-.21854331c-.21166688-.21166688-.55430704-.21155212-.76585916 0l-.21854331.21854331c-.06961948.06961947-.18201785.06958183-.25159968 0l-.21854331-.21854331c-.21166688-.21166688-.55430703-.21155212-.76585915 0l-.21854332.21854331-.2543647.2543647-.12856487.12856487.25712974.25712974z",
    mask: "url(#m)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#f)",
    transform: "translate(.727273 .727273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m2.54545455 2.18181818-2.54545455-2.18181818h.36363636l2.54545455 1.81818182h.72727273l2.90909091-1.81818182v.18181818c0 .10041541-.0629217.22676225-.15160683.29010877l-2.39384772 1.70989123v.72727273l2.40859985 2.06451416c.07558276.06478522.0525152.11730402-.04496349.11730402-.10041541 0-.24473987-.04494407-.333425-.10829059l-2.39384772-1.70989123h-.72727273l-2.90909091 1.81818182v-.36363636l2.54545455-1.81818182z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.09090909 2.99271544-2.85513771-2.44726089h.85513771l.10567967.03386664 2.49804125 1.78431517h.61686158l3.14305386-1.96440866v.50986321c0 .16126093-.09301266.34182269-.22774533.43806031l-2.31770921 1.65550658v.55008131l2.34510737 2.01009203c.20545829.1761071.10087691.43716886-.16328919.43716886-.14042625 0-.32130737-.0580163-.43910468-.14215723l-2.34643442-1.67602459h-.61686158l-3.14305386 1.96440866v-.78524827l2.54545454-1.81818182z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.72727273 2.54545455v1.45454545h2.54545454v1.82153529c0 .19897875.15566184.36028289.36704324.36028289h.72045898c.20271239 0 .36704324-.15691098.36704324-.36028289v-1.82153529h2.55237926c.1970064 0 .35671165-.15566184.35671165-.36704324v-.72045898c0-.20271238-.15640536-.36704323-.35671165-.36704323h-2.55237926v-1.81818182h-1.45454546v1.81818182z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.72727273 2.90909091h2.90909091v-.36363636-1.81818182h.72727272v1.81818182.36363636h2.90909091v.72727273h-2.90909091v.36363636 1.81818182h-.72727272v-1.81818182-.36363636h-2.90909091z",
    fill: "url(#f)",
    mask: "url(#g)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/FK.d1311e41d393db11d19f9b70e47e3855.svg";
export { ForwardRef as ReactComponent };